import { coreSectionPaddingClasses } from '@/constants/measured-scope'
import classNames from 'classnames/bind'
import React from 'react'
import * as styles from './style'
const cx = classNames.bind(styles)

type GridGapSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export interface SharedProps {
  className?: string
  children: React.ReactNode
  tag?: keyof JSX.IntrinsicElements
  fixed?: boolean
}

export interface MainProps {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns
  templateColumns?: string
  maxWidth?: string
  removeDefaultClasses?: boolean
  gap?: GridGapSize
}

export const Main: React.FC<Partial<SharedProps> & MainProps> = ({
  className = '',
  children,
  tag: HTMLTag = 'main',
  templateColumns = '2fr 1.2fr',
  maxWidth = '100%',
  removeDefaultClasses,
  gap = 'md',
}) => {
  const classes = cx({
    [className]: true,
    [styles.main]: true,
    [coreSectionPaddingClasses]: !removeDefaultClasses,
    [styles[`gap_${gap}`]]: true,
  })
  return (
    <HTMLTag className={classes} style={{ '--template-columns': templateColumns, maxWidth } as React.CSSProperties}>
      {children}
    </HTMLTag>
  )
}

export const AsideWrapper: React.FC<Partial<SharedProps>> = ({ className = '', children, tag: HTMLTag = 'div' }) => {
  const classes = cx({
    [className]: true,
    [styles.asideWrapper]: true,
  })
  return <HTMLTag className={classes}>{children}</HTMLTag>
}

export const Aside: React.FC<Partial<SharedProps>> = ({
  className = '',
  children,
  tag: HTMLTag = 'aside',
  fixed = false,
}) => {
  const classes = cx({
    [className]: true,
    [styles.aside]: true,
    fixed,
  })
  return <HTMLTag className={classes}>{children}</HTMLTag>
}

export const Detail: React.FC<Partial<SharedProps>> = ({ className = '', children, tag: HTMLTag = 'section' }) => {
  const classes = cx({
    [className]: true,
    [styles.detail]: true,
  })
  return <HTMLTag className={classes}>{children}</HTMLTag>
}

export const DetailWrapper: React.FC<Partial<SharedProps>> = ({ className = '', children, tag: HTMLTag = 'div' }) => {
  const classes = cx({
    [className]: true,
    [styles.detailWrapper]: true,
  })
  return <HTMLTag className={classes}>{children}</HTMLTag>
}

export default {
  Aside,
  AsideWrapper,
  Detail,
  DetailWrapper,
  Main,
}
